import { Blueprint as ApiBlueprint, Blueprints } from '@leverege/api-attributes';
import BlueprintDataSource from "./dataSource/BlueprintDataSource.js";
import BlueprintHistoryDataSource from "./dataSource/BlueprintHistoryDataSource.js";
export default class Blueprint extends ApiBlueprint {
  /**
   * @deprecated Use Blueprints.get()
   * @returns array of blueprints
   */
  static getAll() {
    return Blueprints.get();
  }

  /**
   * @deprecated Use Blueprints.getByType()
   * @returns a blueprint for the type
   */
  static getByType(type) {
    return Blueprints.getByType(type);
  }
  getDataSource() {
    if (this.dataSource == null) {
      this.dataSource = new BlueprintDataSource(this);
    }
    return this.dataSource;
  }
  getHistoryDataSource() {
    if (this.historyDataSource == null) {
      this.historyDataSource = new BlueprintHistoryDataSource(this);
    }
    return this.historyDataSource;
  }
}